import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { BaseModal } from 'components/UI';
import { Rulesets } from 'components/VehiclesGroups';

const EditReservationsRulesetsModal = ({ open, handleClick, currentVehicleGroup }) => {
  return (
    <BaseModal
      size="lg"
      open={open}
      maxWidth={1160}
      loading={false}
      handleClick={handleClick}
      title={i18n.t('vehicle_groups.edit_rrs')}
    >
      <Rulesets currentGroup={currentVehicleGroup} />
    </BaseModal>
  );
};
EditReservationsRulesetsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  currentVehicleGroup: PropTypes.object.isRequired,
};
EditReservationsRulesetsModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default EditReservationsRulesetsModal;
